module.exports = __webpack_public_path__ + "img/avatar-79.016ff324.png";